// extracted by mini-css-extract-plugin
export default {"header":"ProtectedLayout_header__F7tu8","spacer":"ProtectedLayout_spacer__q7xzI","sider":"ProtectedLayout_sider__7TILA","content":"ProtectedLayout_content__5vDQZ"};